// extracted by mini-css-extract-plugin
module.exports = {"cadSubjectsInformation":"CadSubjectsInformation_cadSubjectsInformation__17xsH","title":"CadSubjectsInformation_title__19uv2","items":"CadSubjectsInformation_items__2PO46"};